<template lang="pug">
  .padding
    .followAccordionWidth
      template(v-if='isConnected')
        h2 Mot de passe perdu
        p Si vous voulez changer votre mot de passe de ce compte, cliquez 
          router-link(:to="{name: 'Profile'}") ici
          | .
        p Si vous voulez changer le mot de passe d'un autre compte (via un email reçu), 
          a(@click='logout', role='button') déconnectez-vous d'abord.
      template(v-else-if='!status')
        h2 Entrez un nouveau mot de passe
        form(@submit.prevent="recoverPassword")
          .form-group(:class="{'has-error': errors.has('Password') }")
            label Nouveau mot de passe
            input.form-control(v-model="newPassword", type="password", v-validate="'required'", name="newPassword")
            span(v-show="errors.has('newPassword')", class="help-block text-danger") {{ errors.first('newPassword') }}
          .form-group(:class="{'has-error': errors.has('confNewPassword') }")
            label Retapez le nouveau mot de passe
            input.form-control(v-model="confNewPassword", type="password", v-validate="'required|match:newPassword'", name="confNewPassword")
            span(v-show="errors.has('confNewPassword')", class="help-block text-danger") {{ errors.first('confNewPassword') }}
          .form-group
            button.btn.btn-primary(type="submit") Définir un nouveau mot de passe
      template(v-else-if='status == "success"')
        h2 C'est un succès !
        p Vous pouvez désormais vous connecter...
        button.btn.btn-primary(@click="connect") Se connecter
      template(v-else-if='status == "InvalidPasswordToken"')
        h2 Oups...
        p Il semble que le lien fourni ne fonctionne pas. Merci de réessayer.
        button.btn.btn-primary(@click="connect") Réessayer
      template(v-else-if='status == "loading"')
        h2 Quelques microsecondes de patience...
        p Nous recherchons les informations.
      template(v-else)
        h2 Oups...
        p Il semble qu'il y ait un problème interne. Merci de réessayer.
        button.btn.btn-primary(@click="connect") Réessayer


</template>
<script type="text/javascript">
import Vue from 'vue'
import api from '@/utils/api'

import {mapGetters} from 'vuex'

export default {
  props: {
    userId: {},
    passwordToken: {}
  },
  data () {
    return {
      newPassword: '',
      confNewPassword: '',
      status: 'loading'
    }
  },
  mounted () {
    this.$validator.extend('match', {
      getMessage: field => Vue.i18n.t('globals.forms.fieldsDoNotMatch'),
      validate: (value, args, field) => this[args[0]] === value
    })
    this.checkValidity()
  },
  destroyed () {
    return this.$validator.remove('match')
  },
  computed: {
    ...mapGetters('user', [
      'isConnected'
    ])
  },
  methods: {
    recoverPassword () {
      this.$validator.validateAll().then(success => {
        console.log(success)
        if (!success) {
          return
        }
        api.post('recoverPassword', {
          userId: this.userId,
          passwordToken: this.passwordToken,
          password: this.newPassword
        }, {__noToken: true}).then(() => {
          this.status = 'success'
        }).catch((error) => {
          this.status = error.response.data.error
        })
      })
    },
    connect () {
      this.$router.replace({name: 'Welcome'})
    },
    checkValidity () {
      this.status = 'loading'
      api.get('passwordTokenExists', {
        params: {
          userId: this.userId,
          passwordToken: this.passwordToken
        },
        __noToken: true
      })
      .then(() => { this.status = false })
      .catch(() => { this.status = 'InvalidPasswordToken' })
    },
    logout () {
      this.$store.dispatch('user/logout')
    }
  },
  watch: {
    userId () {
      this.checkValidity()
    },
    passwordToken () {
      this.checkValidity()
    },
    newPassword () {
      if ((this.confNewPassword != null) && (this.confNewPassword.length > 0)) {
        return this.$validator.validate('confNewPassword', this.confNewPassword)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RecoverPassword.vue?2569182a